import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import * as paymentMethodService from '../../../features/companysettings/services/paymentMethodService';

// Async thunk to fetch payment methods
export const fetchPaymentMethods = createAsyncThunk(
  'paymentMethod/fetchPaymentMethods',
  async (_, { rejectWithValue }) => {
    try {
      const response = await paymentMethodService.getActivePaymentMethods();
      const methods = response?.payload || response?.data || response || [];
      
      if (Array.isArray(methods) && methods.length > 0) {
        return methods.map(m => ({
          id: m.Id,
          value: m.Name.toUpperCase().replace(/\s+/g, '_'),
          label: m.Name,
          name: m.Name,
          isActive: m.IsActive
        }));
      }
      
      return [];
    } catch (error) {
      return rejectWithValue(error.message || 'Failed to fetch payment methods');
    }
  }
);

const initialState = {
  paymentMethods: [],
  loading: false,
  error: null,
  lastFetched: null,
};

const paymentMethodSlice = createSlice({
  name: 'paymentMethod',
  initialState,
  reducers: {
    // Manual update payment methods (if needed)
    setPaymentMethods(state, action) {
      state.paymentMethods = action.payload;
      state.lastFetched = Date.now();
      state.error = null;
    },
    // Add a new payment method
    addPaymentMethod(state, action) {
      state.paymentMethods.push(action.payload);
    },
    // Update a payment method
    updatePaymentMethod(state, action) {
      const index = state.paymentMethods.findIndex(pm => pm.id === action.payload.id);
      if (index !== -1) {
        state.paymentMethods[index] = action.payload;
      }
    },
    // Remove a payment method
    removePaymentMethod(state, action) {
      state.paymentMethods = state.paymentMethods.filter(pm => pm.id !== action.payload);
    },
    // Clear error
    clearError(state) {
      state.error = null;
    },
    // Reset payment methods
    resetPaymentMethods(state) {
      return initialState;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchPaymentMethods.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchPaymentMethods.fulfilled, (state, action) => {
        state.loading = false;
        state.paymentMethods = action.payload;
        state.lastFetched = Date.now();
        state.error = null;
      })
      .addCase(fetchPaymentMethods.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || 'Failed to fetch payment methods';
      });
  },
});

export const {
  setPaymentMethods,
  addPaymentMethod,
  updatePaymentMethod,
  removePaymentMethod,
  clearError,
  resetPaymentMethods,
} = paymentMethodSlice.actions;

export default paymentMethodSlice.reducer;
